export const CATEGORIES = [
  "Restaurant", "Bar", "Cafe", "Bakery", "Salon & Spa", "Retail Store",
  "Contractor", "Professional Service", "Automotive", "Fitness & Wellness",
  "Healthcare", "Real Estate", "Other",
];

export const US_STATES = [
  "HI", "AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA",
  "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN",
  "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH",
  "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA",
  "WI", "WV", "WY",
];

export const SCAN_STAGES = [
  { key: "website", label: "Website", desc: "Structure, speed, SEO, links & CTAs" },
  { key: "business_info", label: "Business information", desc: "Contact details & consistency" },
  { key: "reputation", label: "Reviews & reputation", desc: "Ratings, responses & sentiment" },
  { key: "menu_services", label: "Menu / services", desc: "Pricing, ordering & presentation" },
  { key: "customer_experience", label: "Customer experience", desc: "Conversion & booking paths" },
  { key: "competitive", label: "Competitive opportunities", desc: "Position vs. local competitors" },
];

export const PRIORITY = {
  Critical: { label: "Critical", cls: "text-red-700 bg-red-50 border-red-200", dot: "bg-red-600" },
  High: { label: "High", cls: "text-red-600 bg-red-50 border-red-200", dot: "bg-red-500" },
  Medium: { label: "Medium", cls: "text-orange-600 bg-orange-50 border-orange-200", dot: "bg-orange-500" },
  Low: { label: "Low", cls: "text-amber-700 bg-amber-50 border-amber-200", dot: "bg-amber-500" },
};

export const OPP_PRIORITY = {
  critical: { label: "Critical Priority", ring: "border-l-red-600", chip: "text-red-800 bg-red-100 border-red-300", dot: "🔴" },
  high: { label: "High Priority", ring: "border-l-red-500", chip: "text-red-700 bg-red-50 border-red-200", dot: "🔴" },
  medium: { label: "Medium Priority", ring: "border-l-orange-500", chip: "text-orange-600 bg-orange-50 border-orange-200", dot: "🟠" },
  opportunity: { label: "Opportunity", ring: "border-l-amber-500", chip: "text-amber-700 bg-amber-50 border-amber-200", dot: "🟡" },
};

export const EFFORT = {
  Easy: "text-emerald-700 bg-emerald-50 border-emerald-200",
  Moderate: "text-amber-700 bg-amber-50 border-amber-200",
  Involved: "text-orange-700 bg-orange-50 border-orange-200",
};

export const URGENCY = {
  CRITICAL: { label: "Critical", cls: "text-red-700 bg-red-50 border-red-200", dot: "bg-red-600", rank: 0 },
  HIGH: { label: "High", cls: "text-orange-700 bg-orange-50 border-orange-200", dot: "bg-orange-500", rank: 1 },
  MEDIUM: { label: "Medium", cls: "text-amber-700 bg-amber-50 border-amber-200", dot: "bg-amber-500", rank: 2 },
  LOW: { label: "Low", cls: "text-slate-600 bg-slate-100 border-slate-200", dot: "bg-slate-400", rank: 3 },
  INFORMATIONAL: { label: "Informational", cls: "text-sky-700 bg-sky-50 border-sky-200", dot: "bg-sky-400", rank: 4 },
};
export const urgencyRank = (u) => URGENCY[u]?.rank ?? 5;

export const IMPACT_TYPE_TONE = {
  POTENTIAL_LOSS: { sign: "+", tone: "text-emerald-700", bg: "bg-emerald-50 border-emerald-100", label: "Modeled opportunity" },
  POTENTIAL_REVENUE_OPPORTUNITY: { sign: "+", tone: "text-emerald-700", bg: "bg-emerald-50 border-emerald-100", label: "Estimated opportunity" },
  POTENTIAL_COST_SAVINGS: { sign: "+", tone: "text-emerald-700", bg: "bg-emerald-50 border-emerald-100", label: "Estimated cost savings" },
  COMPLIANCE_RISK: { sign: "", tone: "text-red-700", bg: "bg-red-50 border-red-100", label: "Compliance risk" },
  REPUTATION_RISK: { sign: "", tone: "text-amber-700", bg: "bg-amber-50 border-amber-100", label: "Reputation risk" },
  NOT_ESTIMABLE: { sign: "", tone: "text-slate-500", bg: "bg-slate-50 border-slate-100", label: "Not estimable" },
};

export const COMPLIANCE_STATUS = {
  ACTIVE: { label: "Active", cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  EXPIRED: { label: "Expired", cls: "text-red-700 bg-red-50 border-red-200" },
  SUSPENDED: { label: "Suspended", cls: "text-red-700 bg-red-50 border-red-200" },
  REVOKED: { label: "Revoked", cls: "text-red-700 bg-red-50 border-red-200" },
  PENDING: { label: "Pending", cls: "text-sky-700 bg-sky-50 border-sky-200" },
  NOT_FOUND: { label: "Not found", cls: "text-amber-700 bg-amber-50 border-amber-200" },
  NOT_APPLICABLE: { label: "Not applicable", cls: "text-slate-500 bg-slate-100 border-slate-200" },
  UNABLE_TO_VERIFY: { label: "Unable to verify", cls: "text-slate-600 bg-slate-100 border-slate-200" },
  PENDING_VERIFICATION: { label: "Pending verification", cls: "text-sky-700 bg-sky-50 border-sky-200" },
};
export const COMPLIANCE_BAND = {
  GOOD: { label: "Good", cls: "text-emerald-600", ring: "#059669" },
  ATTENTION: { label: "Attention required", cls: "text-amber-600", ring: "#d97706" },
  CRITICAL: { label: "Critical", cls: "text-red-600", ring: "#dc2626" },
};
// Who verified a license finding — public source vs admin confirmation (never conflated).
export const VERIFIED_BY = {
  PUBLIC_SOURCE: { label: "Verified · Public source", cls: "text-emerald-700 bg-emerald-50 border-emerald-200" },
  ADMIN_CONFIRMED: { label: "Admin confirmed", cls: "text-indigo-700 bg-indigo-50 border-indigo-200" },
  UNVERIFIED: { label: "Unverified · Guidance", cls: "text-slate-500 bg-slate-100 border-slate-200" },
};
// Expiration reminder tiers.
export const REMINDER_TIER = {
  EXPIRED: { label: "Expired", cls: "text-red-700 bg-red-50 border-red-200", dot: "bg-red-600" },
  URGENT: { label: "Urgent", cls: "text-red-700 bg-red-50 border-red-200", dot: "bg-red-500" },
  RENEWAL_SOON: { label: "Renewal soon", cls: "text-amber-700 bg-amber-50 border-amber-200", dot: "bg-amber-500" },
  ACTIVE: { label: "On track", cls: "text-emerald-700 bg-emerald-50 border-emerald-200", dot: "bg-emerald-500" },
};

export const INTEREST_OPTIONS = [
  "Full business audit",
  "Fix my website",
  "Improve my reviews & reputation",
  "Get more customers",
  "Book a business review",
  "Something else",
];

export const TASK_STATUSES = ["NEW", "TO DO", "IN PROGRESS", "WAITING", "DONE", "DISMISSED"];
export const BOARD_COLUMNS = ["NEW", "TO DO", "IN PROGRESS", "WAITING", "DONE"];
export const STATUS_STYLE = {
  "NEW": { chip: "text-slate-700 bg-slate-100 border-slate-200", dot: "bg-slate-400" },
  "TO DO": { chip: "text-indigo-700 bg-indigo-50 border-indigo-200", dot: "bg-indigo-500" },
  "IN PROGRESS": { chip: "text-amber-700 bg-amber-50 border-amber-200", dot: "bg-amber-500" },
  "WAITING": { chip: "text-purple-700 bg-purple-50 border-purple-200", dot: "bg-purple-500" },
  "DONE": { chip: "text-emerald-700 bg-emerald-50 border-emerald-200", dot: "bg-emerald-500" },
  "DISMISSED": { chip: "text-slate-500 bg-slate-100 border-slate-200", dot: "bg-slate-300" },
};

export function scoreColor(score) {
  if (score == null) return "#94a3b8";
  if (score >= 75) return "#059669";
  if (score >= 55) return "#ca8a04";
  if (score >= 40) return "#ea580c";
  return "#dc2626";
}

export function scoreBand(score) {
  if (score == null) return "Unverified";
  if (score >= 75) return "Strong";
  if (score >= 55) return "Moderate";
  if (score >= 40) return "Needs work";
  return "At risk";
}
